export const data = [
  {
    id: 1,
    page: 'About Me',
    url: '/about',
  },
  {
    id: 2,
    page: 'Portfolio',
    url: '/portfolio',
  },
  {
    id: 3,
    page: 'Blog',
    url: '/post',
  }
];
